import type { FC } from 'react';
import { CircleOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const BedOccupiedBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-neutral-100 text-neutral-900">
      <CircleOff aria-hidden className="size-3 shrink-0" />
      {t('component:badge.bedOccupied')}
    </Badge>
  );
};
